import { api } from "../../api/http";

const BASE = "/api/backoffice/courses/";

export async function listCourseTemplates(params = {}) {
	const res = await api.get(BASE, { params });
	return res.data;
}

/** Obtiene un curso (template) por id, con default_run para gestionar contenido. */
export async function getCourseTemplate(id) {
	const res = await api.get(`${BASE}${id}/`);
	return res.data;
}

export async function downloadCourseCertificate(courseId, studentId) {
	const res = await api.get(`${BASE}${courseId}/enrollments/${studentId}/certificate/`, {
		responseType: "blob",
	});
	return res.data;
}

function buildCourseFormData(payload) {
	const form = new FormData();
	if (payload.code != null) form.append("code", payload.code);
	if (payload.name != null) form.append("name", payload.name);
	if (payload.description != null)
		form.append("description", payload.description);
	if (payload.temario != null)
		form.append("temario", payload.temario);
	if (payload.objectives != null)
		form.append("objectives", payload.objectives);
	if (payload.modality != null)
		form.append("modality", payload.modality);
	if (payload.status != null)
		form.append("status", payload.status);
	if (payload.is_active != null)
		form.append("is_active", !!payload.is_active);
	if (payload.price_type != null)
		form.append("price_type", payload.price_type);
	if (payload.price_amount != null && payload.price_amount !== "")
		form.append("price_amount", Number(payload.price_amount));
	if (payload.duration_hours != null && payload.duration_hours !== "")
		form.append("duration_hours", Number(payload.duration_hours));
	if (payload.image instanceof File || payload.image instanceof Blob) form.append("image", payload.image);
	// Run (asesoría): en creación/edición se envía desde el formulario; en parches simples no.
	if (payload.start_date) form.append("start_date", payload.start_date);
	if (payload.end_date) form.append("end_date", payload.end_date);
	if (Object.prototype.hasOwnProperty.call(payload, "schedule")) {
		form.append("schedule", payload.schedule ?? "");
	}
	if (payload.graduation_requirements)
		form.append("graduation_requirements", payload.graduation_requirements);
	if (payload.certificate_emission_enabled != null)
		form.append(
			"certificate_emission_enabled",
			payload.certificate_emission_enabled ? "true" : "false",
		);
	if (Object.prototype.hasOwnProperty.call(payload, "teacher")) {
		form.append(
			"teacher",
			payload.teacher != null && payload.teacher !== ""
				? payload.teacher
				: "",
		);
	}
	if (payload.enrollment_start_date)
		form.append("enrollment_start_date", payload.enrollment_start_date);
	if (payload.enrollment_end_date)
		form.append("enrollment_end_date", payload.enrollment_end_date);
	if (payload.enrollment_url)
		form.append("enrollment_url", payload.enrollment_url);
	if (payload.max_students != null && payload.max_students !== "")
		form.append("max_students", Number(payload.max_students));
	else if (payload.hasOwnProperty("max_students"))
		form.append("max_students", "");
	return form;
}

export async function createCourseTemplate(payload) {
	const res = await api.post(BASE, buildCourseFormData(payload));
	return res.data;
}

export async function updateCourseTemplate(id, payload) {
	const body = buildCourseFormData(payload);
	const res = await api.patch(`${BASE}${id}/`, body);
	return res.data;
}

export async function updateCourseCertificateSettings(id, payload) {
	const res = await api.patch(`${BASE}${id}/`, payload);
	return res.data;
}

export async function deleteCourseTemplate(id) {
	const res = await api.delete(`${BASE}${id}/`);
	return res.data;
}

export async function getCourseSatisfactionSummary(id) {
	const res = await api.get(`${BASE}${id}/satisfaction_summary/`);
	return res.data;
}

/** Inicializa la estructura de la edición del curso (unidad, módulo, contenido, examen) desde backoffice. */
export async function ensureCourseRunStructure(templateId) {
	const res = await api.post(`${BASE}${templateId}/ensure-run-structure/`);
	return res.data;
}

/** Lista estudiantes matriculados en la edición del curso. */
export async function listCourseEnrollments(templateId) {
	const res = await api.get(`${BASE}${templateId}/enrollments/`);
	return res.data;
}

/** Matricula un estudiante en la edición del curso. */
export async function addCourseEnrollment(templateId, studentId) {
	const res = await api.post(`${BASE}${templateId}/enrollments/add/`, {
		student_id: studentId,
	});
	return res.data;
}

/** Da de baja una matrícula (cancela). */
export async function removeCourseEnrollment(templateId, studentId) {
	const res = await api.post(`${BASE}${templateId}/enrollments/remove/`, {
		student_id: studentId,
	});
	return res.data;
}

/** Envía certificados por correo a estudiantes elegibles del curso. */
export async function sendCourseCertificatesByEmail(templateId) {
	const res = await api.post(`${BASE}${templateId}/certificates/send/`);
	return res.data;
}
